// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination-module__paginationContainer___vrFto","navigation":"Pagination-module__navigation___e6knd"};